import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-router-child",
  "use": "icon-router-child-usage",
  "viewBox": "0 0 3 3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 3 3\" id=\"icon-router-child\">\r\n<style type=\"text/css\">\r\n</style>\r\n<rect x=\"0\" class=\"st0\" width=\"3\" height=\"3\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol